import React from "react";

const TransactionsAccount = () => {
  return <div>TransactionsAccount</div>;
};

export default TransactionsAccount;
